export enum WidgetSessionEnum {
    PLANNED_CUSTOMERS_TODAY = 'PLANNED_CUSTOMERS_TODAY',
    PLANNED_TREATMENTS_TODAY = 'PLANNED_TREATMENTS_TODAY',
    CUSTOMERS_WITHOUT_EVOLUTION = 'CUSTOMERS_WITHOUT_EVOLUTION',
    TREATMENTS_WITHOUT_EVOLUTION = 'TREATMENTS_WITHOUT_EVOLUTION',
}
